import React from "react";
import SvgIcon from "@mui/material/SvgIcon";

export default function SkuflixListVideoIcon(props) {
  return (
    <SvgIcon viewBox="0 0 24 24" {...props}>
      <path
        d="M21 5H3"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M10 12H3"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M10 19H3"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M13.9981 12.003C13.9975 11.8256 14.0442 11.6511 14.1334 11.4977C14.2225 11.3442 14.3509 11.2173 14.5053 11.1298C14.6597 11.0424 14.8347 10.9976 15.0121 11.0001C15.1896 11.0026 15.3631 11.0523 15.5151 11.144L20.5121 14.141C20.6608 14.2297 20.784 14.3555 20.8696 14.506C20.9551 14.6566 21.0001 14.8268 21.0001 15C21.0001 15.1732 20.9551 15.3434 20.8696 15.494C20.784 15.6446 20.6608 15.7704 20.5121 15.859L15.5151 18.856C15.3631 18.9478 15.1894 18.9975 15.0119 18.9999C14.8343 19.0024 14.6593 18.9575 14.5049 18.87C14.3504 18.7824 14.2221 18.6553 14.133 18.5017C14.0439 18.3481 13.9973 18.1736 13.9981 17.996V12.003Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </SvgIcon>
  );
}
